var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 10H10V16.25C10 16.5815 9.8683 16.8995 9.63388 17.1339C9.39946 17.3683 9.08152 17.5 8.75 17.5C8.41848 17.5 8.10054 17.3683 7.86612 17.1339C7.6317 16.8995 7.5 16.5815 7.5 16.25V10H1.25C0.918479 10 0.600537 9.8683 0.366117 9.63388C0.131696 9.39946 0 9.08152 0 8.75C0 8.41848 0.131696 8.10054 0.366117 7.86612C0.600537 7.6317 0.918479 7.5 1.25 7.5H7.5V1.25C7.5 0.918479 7.6317 0.600537 7.86612 0.366116C8.10054 0.131696 8.41848 0 8.75 0C9.08152 0 9.39946 0.131696 9.63388 0.366116C9.8683 0.600537 10 0.918479 10 1.25V7.5H16.25C16.5815 7.5 16.8995 7.6317 17.1339 7.86612C17.3683 8.10054 17.5 8.41848 17.5 8.75C17.5 9.08152 17.3683 9.39946 17.1339 9.63388C16.8995 9.8683 16.5815 10 16.25 10Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.f01e2dc025983632711e318123c83e7b.svg";
export { ForwardRef as ReactComponent };